import React, { useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";
import AlertFan from "./AlertFan";
import Silences from "./Silences";
import { AlertFanEditorProps } from "./AlertFanTypes";

export default function AlertTabMain(props: AlertFanEditorProps) {
  const [tab, setTab] = useState(0);
  const [tags, setTags] = useState<{ topics?: Array<string>; items?: Array<string> }>();

  return (
    <TabView activeIndex={tab} onTabChange={e => setTab(e.index)}>
      <TabPanel header={T("word.alerts")}>
        <AlertFan
          setTab={setTab}
          setTags={setTags}
          topicTags={props.topicTags}
          itemTags={props.itemTags}
          loadConf={props.loadConf}
          hiddenColumns={props.hiddenColumns}
          itemsPerPage={props.itemsPerPage}
          updateFrequency={props.updateFrequency}
          showHistoryByDefault={props.showHistoryByDefault}
        />
      </TabPanel>
      <TabPanel header={T("word.alert-fan.silences")}>
        <Silences tags={tags} setTags={setTags} />
      </TabPanel>
    </TabView>
  );
}
